import { replace } from 'connected-react-router'
import { useEffect, useCallback } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import { useLocation } from 'react-router'

import usePrevious from 'hooks/usePrevious'

interface Params {
  hash: `#${string}`
  onActivate?: () => void
  enabled?: boolean
}

/** Used to do something when there is a given hash in the URL */
function useHashSignal({ hash, onActivate, enabled = true }: Params) {
  const dispatch = useAppDispatch()
  const routerLocation = useLocation()

  const hasHash = routerLocation.hash === hash
  const hashSignalActive = hasHash && enabled
  const hashSignalWasActive = usePrevious(hashSignalActive, false)

  useEffect(() => {
    if (hashSignalActive && !hashSignalWasActive && onActivate) {
      onActivate()
    }
  })

  const clearHash = useCallback(() => {
    dispatch(replace({ ...routerLocation, hash: undefined }))
  }, [dispatch, routerLocation])

  return { hasHash, hashSignalActive, clearHash }
}

export default useHashSignal
